export default __webpack_public_path__ + "static/media/us-betsy_ross.5f3fb956.svg";